/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_HeadingInputs */

const tr_mesafeli_s1_heading = /** @type {(inputs: Mesafeli_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Taraflar`)
};

const en_mesafeli_s1_heading = /** @type {(inputs: Mesafeli_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Parties`)
};

const de_mesafeli_s1_heading = /** @type {(inputs: Mesafeli_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Vertragsparteien`)
};

const ru_mesafeli_s1_heading = /** @type {(inputs: Mesafeli_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Стороны`)
};

/**
* | output |
* | --- |
* | "1. Parties" |
*
* @param {Mesafeli_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_heading = /** @type {((inputs?: Mesafeli_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_heading(inputs)
	if (locale === "de") return de_mesafeli_s1_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s1_heading(inputs)
	return tr_mesafeli_s1_heading(inputs)
});